export default __webpack_public_path__ + "static/media/onlineBanking.90d8c19d.svg";